/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-11-10 14:01:52
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-11-24 10:29:08
 * @FilePath: /low-code/src/icons/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
// svg组件
import SvgIcon from '@/components/svg-icon'

// register globally
// Vue.component('SvgIcon', SvgIcon)
const iconMap = []

const req = require.context('./svgs', !0, /\.svg$/)
// 获取文件名
const getFileName = (path) => {
  const pathArr = path.split('/')
  return pathArr.pop()
}
const requireAll = requireContext => {
  requireContext.keys().map((key) => {
    const fileName = './config-list/'
    if(key.indexOf(fileName) > -1) {
      const value = getFileName(key).replace('.svg', '')
      const iconData = {
        label: value,
        value
      }
      iconMap.push(iconData)
    }
    return requireContext(key)
  })
}
requireAll(req)
export const iconList = iconMap